import { Form } from "antd";
import { HeaderOverview, IRenderBarChart, RenderBarChart } from "components";
import dayjs from "config/dayjs";
import {
  ErrorDashboard,
  LoadingDashboard,
  NoDataDashboard,
  WrapperBG,
  checkData,
} from "pages/overview";
import { useOverview } from "providers/overview";
import { useTranslation } from "react-i18next";
import { useGetDashboardRepairingGraphPerDay } from "service/dashboard/central/homecare";
import { IData } from "service/dashboard/interface";

const Workload = () => {
  const { t } = useTranslation();
  const { findDate, property } = useOverview();

  const dailyWorkloadDate = Form.useWatch("dailyWorkloadDate");
  const date = findDate(dailyWorkloadDate);

  const { data, isFetching, isError, error } =
    useGetDashboardRepairingGraphPerDay({ ...date, property });

  const findData = checkData(data);

  const getData: IData[] =
    findData?.map((e) => {
      const date = dayjs(e.day).date();
      return { name: `${date}`, count: e?.count || 0 };
    }) || [];

  const findNoCount = getData.some((e) => (e.count || 0) > 0);

  const dataBar: IRenderBarChart = {
    data: getData,
    dataKeyX: "name",
    dataKeyY: "count",
    color: "#BBD649",
  };

  return (
    <WrapperBG>
      <LoadingDashboard loading={isFetching}>
        <HeaderOverview title={t("daily-workload")} name="dailyWorkloadDate" />
        {isError ? (
          <ErrorDashboard error={error} height="300px" />
        ) : !findData || findData.length <= 0 || !findNoCount ? (
          <NoDataDashboard height="300px" />
        ) : (
          <RenderBarChart {...dataBar} />
        )}
      </LoadingDashboard>
    </WrapperBG>
  );
};

export default Workload;
